import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';

import {RhynoApiProvider} from '../../providers/rhyno-api/rhyno-api';
import {LeistungProvider} from '../../providers/leistung/leistung';

/**
 * Generated class for the SelectProjectPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-select-project',
  templateUrl: 'select-project.html',
})
export class SelectProjectPage {
	Projekte = [];
  loading: any;
  mode = {create:true};

  constructor(public navCtrl: NavController, 
  	public navParams: NavParams, 
  	private rhynoApi: RhynoApiProvider,
    public loadingCtrl: LoadingController,
  	public leistungCtrl: LeistungProvider) {

    this.mode = navParams.data;

		this.getData();

  }
  doRefresh(refresher){
    this.getData();
    refresher.complete();
  }
  getData(){
    this.loading = this.loadingCtrl.create({
      content: 'einen Moment...'
    });
    this.loading.present();

    this.rhynoApi.getProjekt({}).subscribe(
      data => {
      if (data.success){
        this.Projekte = data.data; 
        console.log(data);
      }
      this.loading.dismiss();
    },
      err => {
      console.log(err);
      this.loading.dismiss();
    },
    () => console.log('Projekte Search Complete')
    );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SelectProjectPage');
  }
  select(data){
    this.leistungCtrl.setProject(data, this.mode.create);
  	this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/select-project/select-project.ts